import React from "react";

import styled from "styled-components";

const Container = styled.label`
    display: inline-flex;
    align-items: center;
    cursor: ${(props) => (props.disabled ? "inherit" : "pointer")};
    user-select: none;
`;

const RadioInput = styled.input`
    margin-right: ${(props) => props.marginRight || "10px"};
    accent-color: ${(props) => props.accentColor || "var(--color-Key)"};
`;

const LabelText = styled.span`
    font-size: ${(props) => props.fontSize || "1.4rem"};
    color: ${(props) => (props.disabled ? "var(--color-DisabledText)" : props.color || "var(--color-Black)")};
    user-select: text;
`;

function RadioButton({ label, labelColor, labelFontSize, labelProps, marginRight, accentColor, disabled, ...rest }) {
    const input = (
        <RadioInput type="radio" marginRight={marginRight} accentColor={accentColor} disabled={disabled} {...rest} />
    );

    if (!label) {
        return input;
    }

    return (
        <Container disabled={disabled}>
            {input}
            <LabelText disabled={disabled} color={labelColor} fontSize={labelFontSize} {...labelProps}>
                {label}
            </LabelText>
        </Container>
    );
}

export default RadioButton;
